import { VFC } from 'react';
import classNames from 'classnames';
import useCommercialize from '@hooks/useCommercialize';
import { PayBadge, UpdateModal } from '@tencent/calendar-web-component-pc-biz';
import PosterConfigList from './PosterConfigList';
import './index.scss';
export interface PosterItem {
  logo: {
    show: boolean; // 是否配置logo
    src?: string; // logo src
  };
  title: {
    show?: boolean; // 是否配置活动主题名称
    line?: number; // 主题显示行数
  };
  host: {
    show?: boolean; // 是否配置主办方
    line?: number; // 主办方显示行数
    extra?: React.ReactNode | string;
  };
  cover?: boolean; // 是否配置活动封面
  time: {
    show: boolean; // 是否配置活动时间
    extra?: React.ReactNode | string;
  };
  location: {
    show: boolean; // 是否配置地址
    line?: number; // 显示行数
    extra?: React.ReactNode | string;
  };
  qrcode: {
    type: number; // 底部二维码组件类型 共6种
    logo?: string; // 底部二维码logo
  }; // 自定义报名二维码组件，共6种
  posterId: number; // 海报id
  thumbnail: string; // 缩略图
}
interface IProp {
  posters?: PosterItem[];
  className?: string;
  selectedPoster: number;
  onSelect: (id: number) => void;
}
export const DEFAULT_POSTER_ID = 0;
const PosterList: VFC<IProp> = ({ posters, selectedPoster, onSelect, className }) => {
  const list = posters || PosterConfigList;
  const { vipResource } = useCommercialize();
  const { shared_poster_type: posterType } = vipResource?.rule || {};
  const hasPosterPermission = Number(posterType) === 1;
  const showUpdateModal = () => {
    UpdateModal.show({
      title: '该功能为付费功能',
      content: '当前版本仅能使用基础海报，如需使用更多风格海报，请前往升级版本',
      onBtnClick: () => {
        window.open('/events/host/service-order', '_self');
      },
    });
  };
  return (
    <div className={classNames('poster-list', className)}>
      {list.map((i, posterId) => {
        const isDefaultPoster = posterId === DEFAULT_POSTER_ID;
        return (
          <div
            className={classNames('poster-list-thumbnail', {
              selected: posterId === selectedPoster,
            })}
            key={posterId}
            onClick={() => {
              if (!isDefaultPoster && !hasPosterPermission) {
                showUpdateModal();
                return;
              }
              onSelect(posterId);
            }}
          >
            {!isDefaultPoster && !hasPosterPermission && (
              <PayBadge type="right" className="poster-pay-badge" />
            )}
            <img src={i.thumbnail} className="poster-list-img" />
          </div>
        );
      })}
    </div>
  );
};
export default PosterList;
